import React, { useEffect } from "react";
import Input from "~/common/components/Input";
import Form from "~/common/components/Form";
import NumberInput from "~/common/components/NumberInput";

const Short = ({ useForm, form, apply, companyInfoData, setCompanyInfoValue, companyTypeSel }) => {

	const formContent = form.content;
	useEffect(() => {
		useForm.setValue(form.order.toString(), form.answer);
	}, []);

	// 기업정보 있을시 setValue
	useEffect(() => {
		companyInfoData && setCompanyInfoValue(form, useForm, form.content)
	}, [companyInfoData]);

	useEffect(() => {
		if(companyTypeSel === "예비 창업") {
			if(form.content === "regNum") {
				useForm.setValue(form.order.toString(), "000-00-00000");
			}
		}
		if(companyTypeSel === "개인 사업자" || companyTypeSel === "법인 사업자") {
			if(form.content === "regNum") {
				useForm.setValue(form.order.toString(), companyInfoData.company.regNum);
			}
		}
	}, [companyTypeSel])


	return (
		<>
			<Form useForm={useForm}>
				{
					// 사업자등록번호
					form.content === "regNum" ?
						<NumberInput
							label={form.title}
							placeholder="000-00-00000"
							name={form.order.toString()}
							type="company"
							required={form.required}
							readonly={(apply || companyTypeSel === "예비 창업")}
						/> :
						// 직원 수
						form.content === "employeeNum" ?
							<NumberInput
								label={form.title}
								name={form.order.toString()}
								className={`${form.required ? "required": ""}`}
								required={form.required}
								string
								readonly={apply}
							/> :
							form.content === "salesNum" ?
								<NumberInput
									label={form.title}
									name={form.order.toString()}
									max={999999999}
									required={form.required}
									string
									readonly={apply}
								/>:
								<Input
									label={form.title}
									name={form.order.toString()}
									required={form.required}
									readonly={apply}
								/>
				}
			</Form>
		</>
	);
};

export default Short;
